import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=04e96cc2&"
import script from "./PricingView.vue?vue&type=script&lang=js&"
export * from "./PricingView.vue?vue&type=script&lang=js&"
import style0 from "./PricingView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports